module.exports = __webpack_public_path__ + "static/media/KennonMOBILE.90246c7c.mp4";